import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment as ENV } from '../../environments/environment';
import { DocumentTemplate } from '../models/Template';
import { tap } from 'rxjs/operators';


@Injectable({ providedIn: "root" })
export class TemplateService {
    constructor(public http: HttpClient) { }

    private readonly changesSubj = new Subject();

    public get apiUrl(): string { return `${ENV.apiUrl}/templates` }

    get(id: number): Observable<DocumentTemplate> {
        const url = `${this.apiUrl}/${id}`;
        return this.http.get<DocumentTemplate>(url);
    }

    getFileUrl(id: number | string, language?: string): string {
        return `${this.apiUrl}/${id}/file${language ? `?language=${language}` : ''}`;
    }

    getAll(): Observable<DocumentTemplate[]> {
        const url = `${this.apiUrl}`;
        return this.http.get<DocumentTemplate[]>(url);
    }

    add(documentTemplate: DocumentTemplate): Observable<DocumentTemplate> {
        const url = `${this.apiUrl}`;
        return this.http.post<DocumentTemplate>(url, documentTemplate).pipe(tap(() => {
            this.changesSubj.next();
        }));
    }

    update(documentTemplate: DocumentTemplate): Observable<DocumentTemplate> {
        const url = `${this.apiUrl}/${documentTemplate.Id}`;
        return this.http.put<DocumentTemplate>(url, documentTemplate).pipe(tap(() => {
            this.changesSubj.next();
        }));
    }

    delete(id: number): Observable<boolean> {
        const url = `${this.apiUrl}/${id}`;
        return this.http.delete<boolean>(url).pipe(tap(() => {
            this.changesSubj.next();
        }));
    }

    getChanges() {
        return this.changesSubj.asObservable();
    }
}
